import { render, staticRenderFns } from "./double-eleven-2020.vue?vue&type=template&id=3141fccc&scoped=true&"
import script from "./double-eleven-2020.vue?vue&type=script&lang=js&"
export * from "./double-eleven-2020.vue?vue&type=script&lang=js&"
import style0 from "./double-eleven-2020.vue?vue&type=style&index=0&id=3141fccc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3141fccc",
  null
  
)

export default component.exports